<template>
  <div>
    
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Cihaz</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <!-- <router-link v-if="$helper.sayfayetki(516410)" to="/create/cihaz"><button type="submit" class="btn submit bg-dark text-light">Yeni Cihaz</button>
          </router-link> -->
          <router-link to="/defines/cihazgrup"><button type="submit" class="btn submit bg-dark text-light mr-w">Ana Gruplar</button>
          </router-link>
          <router-link to="/gruplama/altgrup"><button type="submit" class="btn submit bg-dark text-light">Alt Gruplar</button>
          </router-link>          
          <router-link v-if="$helper.sayfayetki(493225)" to="/grafik/cihaz"><button type="submit" class="btn submit bg-dark text-light">Grafik Gösterim</button>
          </router-link>
          <!-- <button @click="refresh()"  class="btn btn-primary submit bg-dark text-light">Yenile</button> -->
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
    <div class="container-fluid">
      <div class="row">
              <div class="col-md-3 col-sm-6">
                <div class="statistic-block block">
                  <div class="progress-details d-flex align-items-end justify-content-between">
                    <div class="title">
                      <div class="icon"><i class="icon-contract"></i></div><strong>Toplam Cİhaz</strong>
                    </div>
                    <div class="number dashtext-3">{{posts.length}}</div>
                  </div>
                  <div class="progress progress-template">
                    <div role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-template dashbg-3"></div>
                  </div>
                </div>
              </div>
              <div v-for="(bir,iki) in this.$helper.groupByAdet(posts,'cd')" :key="bir"  class="col-md-3 col-sm-6">
                <div class="statistic-block block">
                  <div class="progress-details d-flex align-items-end justify-content-between">
                    <div class="title">
                      <div class="icon"><i class="icon-contract"></i></div><strong>{{$helper.ilkharfBuyuk(iki)}}</strong>
                    </div> 
                    <div class="number dashtext-2">{{bir}}</div>
                  </div>
                  <div class="progress progress-template">
                    <div role="progressbar" v-bind:style="{width :  (bir / posts.length)*100 + '%' }" class="progress-bar progress-bar-template dashbg-2"></div>
                  </div>
                </div>
              </div>
            </div>
    </div>
    <div class="row mb-2 p-2">
      <div class="col-12">
        <button class="btn btn-outline-primary mr-2 mt-3" @click="filter('All')">Tümü</button>
        <button class="btn btn-outline-secondary mr-2 mt-3" v-for="(key,value) in this.$helper.groupByAdet(posts,'cd')" :key="key" @click="filter(value)">{{$helper.ilkharfBuyuk(value)}}</button>
      </div>

    </div>
    <div class="row mt-3 mb-3">
      <div class="col-12">
          <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
         <div class="block margin-bottom-sm">
            <div class="table-responsive"> 
               <table id="tablo" class="table table-striped">
                  <thead>
                    <tr>
                     <th>Marka</th>
                      <th>Model</th>
                      <th>Barkod</th>
                      <th>Serino</th>
                      <th>Cari</th>
                      <th>Lokasyon</th>
                      <!-- <th>Sağlayıcı</th> -->
                      <th>Durum</th>
                      <th>Yaş</th>
                      <th>Detay</th>
                      <th>Servis</th>

                    </tr>
                  </thead>
                  <tbody>
                   <tr v-for="(post,index) in filteredItems(posts,'cd')" :key="index">
                    <!-- <td>{{post.cihazid}}</td> -->
                   <td>{{$helper.ilkharfBuyuk(post.cihazgrup)}}</td>
                    <td>{{$helper.ilkharfBuyuk(post.cihazaltgrup)}}</td>
                    <td>{{post.barkod}}</td>

                    <td>{{post.chz_serino}}</td>
                    <td>{{$helper.ilkharfBuyuk(post.unvan)}}</td>
                    <td>{{$helper.ilkharfBuyuk(post.lokasyon)}}</td>
                    <!-- <td>{{post.saglayici}}</td> -->
                    <td class="dashtext-3">{{$helper.ilkharfBuyuk(post.cd)}}</td>
                    <td class="dashtext-5">{{(parseInt($helper.gunhesapla(post.ktarih)/365))}}</td>
                    <td v-if="$helper.sayfayetki(227916)">
                      <router-link :to="`/detay/cihaz/${post.cihazid}`">Detay</router-link>
                    </td>
                    <td class="text-center"  v-if="$helper.sayfayetki(227916)">
                      <router-link :to="`/create/servis/cihaz/${post.cihazid}`"><i class="fa fa-plus"></i></router-link>
                    </td>
                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
    </div>
</template>
<script>
  export default {
    async created() {
      this.progres.inprogres = true
      this.yetki();
    },
    data() {
      return {
        search: '',
        table :'cihaz', //this.$route.params.cihaz,,
        posts: [],
        errors: [],
        currentTag: 'All',
        firma:this.$request.ayar().firmaid,
        ya:this.$request.ayar().ya,
        kid:this.$request.ayar().kid,
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        },
        //source:this.$store.getters.getsource
      };
    },

    
    methods: {

        yetki: function(){ // sayfa yetki
          if (this.$helper.sayfayetki(771713)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
            }
                if(islem){this.getPostsAsync()}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
        getPostsAsync() {
          
          this.progres.inprogres = true
          this.$request.post("servis/api", {q:'cihaz_list',isim:this.$request.ayar().f1,where:{}}).then(res => {
            console.log(res.data)
            this.posts = res.data
            this.progres.inprogres = false


          }) 

        },
        refresh(){
          this.progres.inprogres = true
          this.$request.post("servis/api", {q:'cihaz_list',isim:this.$request.ayar().f1,where:{}}).then(res => {
          this.$store.dispatch("source",res.data).then(ok=>{
          this.progres.inprogres = false
          })

          })          
        },

        filter: function(tag) {
          this.currentTag = tag;
        },

        filteredItems: function(array,field) {
        var filter = this.currentTag;
        if (filter == 'All' ){
            return array
        }
        else{
              return array.filter(function(item) {
              return item[field].indexOf(filter) !== -1;
          });
        }
        }
    }

  };
</script>
<style scoped>
@media
	  only screen 
    and (max-width: 760px), (min-device-width: 768px) 
    and (max-device-width: 1024px)  {
		table, thead, tbody, th, td, tr {
			display: block;
		}
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}
    tr {
      margin: 0 0 1rem 0;
    }
    tr:nth-child(odd) {
      background: #ccc;
    }
		td {
			border: none;
			border-bottom: 1px solid #eee;padding-left: 50%;
			position: relative;
		}
		td:before {
			position: absolute;
			top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap;
		}
		td:nth-of-type(1):before { content: "id"; }
		td:nth-of-type(2):before { content: "Alias"; }
		td:nth-of-type(3):before { content: "Model"; }
		td:nth-of-type(4):before { content: "Barkod"; }
		td:nth-of-type(5):before { content: "Cari"; }
		td:nth-of-type(6):before { content: "Durum"; }
		td:nth-of-type(7):before { content: "Detay"; }
	}
@media screen and (min-width: 992px) and (max-width: 2000px) {
table, td, th {  
  /*border: 1px solid #ddd;*/
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding:15px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/cihaz/Cihaz.vue